module.exports = __webpack_public_path__ + "2ec3bf7a54ced8e9d7f6a00904d1967e.svg";